<div class="dialog-container">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'pages.inspectionDetailsDialog.title' | translate }}</h2>
        <button mat-icon-button class="close-button" (click)="onClose()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
        <app-inspection-results-detail [point]="point"></app-inspection-results-detail>
    </div>
</div>
